import React from 'react';
import ModerationProfileGeneralInformations from './components/moderationProfileGeneralInformations';
import ModerationProfileRequesterInformations from './components/moderationProfileRequesterInformations';
import ModerationProfileAttendeeInformations from './components/moderationProfileAttendeeInformations';
import ModerationProfileHistory from './components/moderationProfileHistory';

export const ModerationProfileLeftContainer = ({
    attendee,
    order,
    organization,
    flowId,
    historyDatas,
    loadingHistoryDatas,
    syncOrder,
    syncHistoryDatas,
    syncAttendee,
    eventLogsHistoryDatas
}) => {
    return (
        <>
            <ModerationProfileGeneralInformations order={order} attendee={attendee} />
            {!attendee.event_spam_moderation && (
                <ModerationProfileRequesterInformations
                    order={order}
                    organizationId={organization.id}
                    orderId={attendee?.order}
                    flowId={flowId}
                    syncOrder={syncOrder}
                    attendee={attendee}
                />
            )}
            <ModerationProfileAttendeeInformations attendee={attendee} organizationId={organization.id} flowId={flowId} syncAttendee={syncAttendee} />
            <ModerationProfileHistory
                organizationId={organization.pk}
                flowId={flowId}
                attendee={attendee}
                historyDatas={historyDatas}
                eventLogsHistoryDatas={eventLogsHistoryDatas}
                syncHistory={syncHistoryDatas}
                loadingHistoryDatas={loadingHistoryDatas}
            />
        </>
    );
};
